var map = {
	"./banner_img1.png": "FIs6",
	"./banner_img2.png": "pz1z",
	"./banner_img3.png": "8dFy",
	"./icon1.png": "HWEK",
	"./icon2.png": "HosE",
	"./icon3.png": "y9FJ",
	"./icon4.png": "K3X3",
	"./icon5.png": "7p1c",
	"./icon6.png": "OAQh",
	"./kh-0.png": "fExq",
	"./kh-1.png": "7Wpk",
	"./kh-10.png": "M28N",
	"./kh-11.png": "FSJ+",
	"./kh-12.png": "vJ6M",
	"./kh-13.png": "EHNc",
	"./kh-14.png": "PceH",
	"./kh-2.png": "h4Ow",
	"./kh-3.png": "mnjw",
	"./kh-4.png": "BNTQ",
	"./kh-5.png": "alKr",
	"./kh-6.png": "zFPc",
	"./kh-7.png": "CPzb",
	"./kh-8.png": "btgm",
	"./kh-9.png": "Qd+k",
	"./logo.png": "7Otq",
	"./slide_small0.png": "Nody",
	"./slide_small1.png": "p2lZ",
	"./slide_small2.png": "ojg0",
	"./slide_small3.png": "82mf",
	"./slide_small4.png": "411x"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 4